import { render, staticRenderFns } from "./SectionTuileDouble.vue?vue&type=template&id=cd18509a&scoped=true&"
import script from "./SectionTuileDouble.vue?vue&type=script&lang=ts&"
export * from "./SectionTuileDouble.vue?vue&type=script&lang=ts&"
import style0 from "./SectionTuileDouble.vue?vue&type=style&index=0&id=cd18509a&scoped=true&lang=css&"
import style1 from "./SectionTuileDouble.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd18509a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardTitle,VCol,VContainer,VImg,VRow})
